import { render, staticRenderFns } from "./DHeader.vue?vue&type=template&id=4b6428dc&scoped=true&"
import script from "./DHeader.vue?vue&type=script&lang=js&"
export * from "./DHeader.vue?vue&type=script&lang=js&"
import style0 from "./DHeader.vue?vue&type=style&index=0&id=4b6428dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6428dc",
  null
  
)

export default component.exports